<script>
import { Bar } from 'vue-chartjs'
export default {
    name: 'billsToReceive',
    extends: Bar,
    props: [
        "options",
        "chartData"
    ],
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
}
</script>
<style scoped>

</style>